import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import * as dayjs from 'dayjs';
import InlineSpinner from 'components/atoms/Spinner/InlineSpinner';
import { productLink } from 'productLink';
import { urls } from '../productLinks';

const Button = () => {
  const { priceProduct } = useSelector((state) => state.siteInfo);
  return (
    <button type='button' className='main-btn'>
      {priceProduct ? 'BUY NOW' : <InlineSpinner />}
    </button>
  );
};

export const ProductHeroButton = ({ isJapanese, language }) => {
  const entitlement = useSelector((state) => state.entitlement);
  const [entitlementHasExpired, setEntitlementExpired] = useState(false);
  useMemo(() => {
    const today = new Date();
    if (entitlement !== null) {
      setEntitlementExpired(dayjs().isAfter(dayjs(entitlement.expiration), today));
    }
  }, [entitlement]);
  return (
    <>
      {isJapanese
        ? (
          <a href={productLink} target='_blank' rel='noreferrer'>
            <Button entitlement={entitlement} entitlementHasExpired={entitlementHasExpired} isJapanese={isJapanese} />
          </a>
        )
        : (
          <Link to={urls.checkout[language]}>
            <Button entitlement={entitlement} entitlementHasExpired={entitlementHasExpired} />
          </Link>
        )}
    </>
  );
};

ProductHeroButton.propTypes = {
  isJapanese: PropTypes.bool.isRequired,
  language: PropTypes.string.isRequired,
};
